module.exports = __webpack_public_path__ + "static/media/close.27191700.svg";